import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';

var SvgAus = function SvgAus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.5 6 .297.946.906-.352-.536.828.833.507-.965.086.133.985-.668-.72-.668.72.133-.985L23 7.93l.833-.507-.536-.828.906.352L24.5 6Zm4 4 .297.946.906-.352-.536.828.833.507-.965.086.133.985-.668-.72-.668.72.133-.985L27 11.93l.833-.507-.536-.828.906.352L28.5 10Zm-8 1 .297.946.906-.352-.536.828.833.507-.965.086.133.985-.668-.72-.668.72.133-.985L19 12.93l.833-.507-.536-.828.906.352L20.5 11Zm4 8 .297.946.906-.352-.536.828.833.507-.965.087.133.984-.668-.72-.668.72.133-.985L23 20.93l.833-.507-.536-.828.906.352L24.5 19Zm1.5-5 .224.774H27l-.612.473.224.753-.612-.473-.612.452.224-.732-.612-.473h.755L26 14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
    fill: "#227FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.886 0 8 6.114 14.114 0H16v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H0v-1.886L6.114 8 0 1.886V0h1.886Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.875 8.544.6 10 .4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333.498V16H6.666V1.114C7.402.867 8.313.662 9.334.498Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
    fill: "#E94B35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8 23 .593 1.892 1.813-.704-1.073 1.656L11 26.86l-1.93.172L9.334 29 8 27.56 6.665 29l.266-1.97L5 26.86l1.667-1.015-1.073-1.656 1.813.704L8 23Z",
    fill: "#fff"
  }));
};

export default SvgAus;